var map = {
	"./Amex.svg": 1706,
	"./Apple.svg": 1707,
	"./Arrow-Coverage-Dark.svg": 1708,
	"./Arrow-Coverage-Light.svg": 1709,
	"./Arrow-Coverage.svg": 1710,
	"./Arrow-Element.svg": 1711,
	"./Arrow-Macro-Light.svg": 1712,
	"./Arrow-Macro.svg": 1713,
	"./Arrow-Micro-Dark.svg": 1714,
	"./Arrow-Micro.svg": 1715,
	"./Auth.svg": 1716,
	"./Close-Dark.svg": 1717,
	"./Close-Light.svg": 1718,
	"./Coverage-Dark.svg": 1719,
	"./Coverage-Light.svg": 1720,
	"./Credit-Card.svg": 1721,
	"./Data-Dark-16.svg": 1722,
	"./Data-Dark.svg": 1723,
	"./Data-Light-16.svg": 1724,
	"./Data-Light.svg": 1725,
	"./Down-Arrow.svg": 1726,
	"./Facebook-Original.svg": 1727,
	"./Footer-Amex.svg": 1728,
	"./Footer-Arrow-Close.svg": 1729,
	"./Footer-Arrow-Open.svg": 1730,
	"./Footer-Facebook.svg": 1731,
	"./Footer-Instagram.svg": 1732,
	"./Footer-Linkedin.svg": 1733,
	"./Footer-MasterCard.svg": 1734,
	"./Footer-Paypal.svg": 1735,
	"./Footer-Twitter.svg": 1736,
	"./Footer-VK.svg": 1737,
	"./Footer-Visa.svg": 1738,
	"./Footer-X.svg": 1739,
	"./GooglePlayStore.svg": 1740,
	"./ID.svg": 1741,
	"./Information.svg": 1742,
	"./Inline-American-Express.svg": 1743,
	"./Inline-MasterCard.svg": 1744,
	"./Inline-Unionpay.svg": 1745,
	"./Inline-Visa.svg": 1746,
	"./Input-Search-Dark.svg": 1747,
	"./Input-Search-Light.svg": 1748,
	"./Linkedin-Light.svg": 1749,
	"./Log-out-red.svg": 1750,
	"./Log-out.svg": 1751,
	"./Logo.svg": 1752,
	"./Manual-Install.svg": 1753,
	"./Mastercard.svg": 1754,
	"./PayPal.svg": 1755,
	"./Plus.svg": 1756,
	"./Price-Dark.svg": 1757,
	"./Price-Light.svg": 1758,
	"./QR.svg": 1759,
	"./Readonly-Input-Lock.svg": 1760,
	"./Saved-Amex.svg": 1761,
	"./Saved-MasterCard.svg": 1762,
	"./Saved-Visa.svg": 1763,
	"./Search.svg": 1764,
	"./Secure-Auth.svg": 1765,
	"./Secure-W.svg": 1766,
	"./Secure.svg": 1767,
	"./Share.svg": 1768,
	"./Star_color.svg": 1769,
	"./Store-Active-Dark.svg": 1770,
	"./Store-Active-Light.svg": 1771,
	"./Store-B.svg": 1772,
	"./Store-Inactive.svg": 1773,
	"./Store-W.svg": 1774,
	"./Store.svg": 1775,
	"./Success.svg": 1776,
	"./Trash.svg": 1777,
	"./Twitter-Original.svg": 1778,
	"./User-Active-Dark.svg": 1779,
	"./User-Active-Light.svg": 1780,
	"./User-Inactive.svg": 1781,
	"./Validity-Dark.svg": 1782,
	"./Validity-Light.svg": 1783,
	"./Visa.svg": 1784,
	"./What-is-This.svg": 1785,
	"./copy.svg": 1786,
	"./eSIM-Active-Dark.svg": 1787,
	"./eSIM-Active-Light.svg": 1788,
	"./eSIM-Dark.svg": 1789,
	"./eSIM-Inactive.svg": 1790,
	"./eSIM-Light.svg": 1791,
	"./email.svg": 1792,
	"./facebook.svg": 1793,
	"./ic_add-card.svg": 1794,
	"./ic_airmoney_macro.svg": 1795,
	"./ic_airmoney_micro.svg": 1796,
	"./ic_airmoney_pay.svg": 1797,
	"./ic_airmoney_payment-method.svg": 1798,
	"./ic_alipay_payment-method-dark.svg": 1799,
	"./ic_alipay_payment-method-light.svg": 1800,
	"./ic_amex.svg": 1801,
	"./ic_apple-dark.svg": 1802,
	"./ic_apple-light.svg": 1803,
	"./ic_apple-pay_payment-method.svg": 1804,
	"./ic_arrow_slider_active_Light.svg": 1805,
	"./ic_arrow_slider_inactive_Light.svg": 1806,
	"./ic_back_header-dark.svg": 1807,
	"./ic_back_header-light.svg": 1808,
	"./ic_banner_refeere.svg": 1809,
	"./ic_banner_referrer.svg": 1810,
	"./ic_bill_to_org_payment-method-light.svg": 1811,
	"./ic_calls.svg": 1812,
	"./ic_checkbox_active.svg": 1813,
	"./ic_checkbox_inactive.svg": 1814,
	"./ic_chevron-right.svg": 1815,
	"./ic_chip.svg": 1816,
	"./ic_clear.svg": 1817,
	"./ic_close_white.svg": 1818,
	"./ic_copy.svg": 1819,
	"./ic_coverage.svg": 1820,
	"./ic_credit-card_payment-method-dark.svg": 1821,
	"./ic_credit-card_payment-method-light.svg": 1822,
	"./ic_data.svg": 1823,
	"./ic_delete_white.svg": 1824,
	"./ic_discount-code.svg": 1825,
	"./ic_edit_white.svg": 1826,
	"./ic_esim.svg": 1827,
	"./ic_expire.svg": 1828,
	"./ic_fup.svg": 1829,
	"./ic_google-pay.svg": 1830,
	"./ic_google-pay_payment-method.svg": 1831,
	"./ic_google.svg": 1832,
	"./ic_help_center.svg": 1833,
	"./ic_install.svg": 1834,
	"./ic_jcb.svg": 1835,
	"./ic_logout.svg": 1836,
	"./ic_long-back-arrow.svg": 1837,
	"./ic_manual_install.svg": 1838,
	"./ic_mastercard.svg": 1839,
	"./ic_notification.svg": 1840,
	"./ic_package.svg": 1841,
	"./ic_paypal_payment-method-dark.svg": 1842,
	"./ic_paypal_payment-method-light.svg": 1843,
	"./ic_play.svg": 1844,
	"./ic_price.svg": 1845,
	"./ic_price_v2.svg": 1846,
	"./ic_qrcode_install.svg": 1847,
	"./ic_routing.svg": 1848,
	"./ic_screenshot.svg": 1849,
	"./ic_sms.svg": 1850,
	"./ic_statistic.svg": 1851,
	"./ic_store_header.svg": 1852,
	"./ic_stripe.svg": 1853,
	"./ic_subscription.svg": 1854,
	"./ic_success.svg": 1855,
	"./ic_success_banner.svg": 1856,
	"./ic_success_order-completed.svg": 1857,
	"./ic_telegram.svg": 1858,
	"./ic_tips.svg": 1859,
	"./ic_unionpay.svg": 1860,
	"./ic_validity.svg": 1861,
	"./ic_visa.svg": 1862,
	"./ic_visa_payment-method.svg": 1863,
	"./ic_visa_saved-card.svg": 1864,
	"./ic_whatsapp.svg": 1865,
	"./icon-ekyc-detail-card-info.svg": 1866,
	"./icon-ekyc-detail-driver-license.svg": 1867,
	"./icon-ekyc-detail-faq-arrow.svg": 1868,
	"./icon-ekyc-detail-finger-print.svg": 1869,
	"./icon-ekyc-detail-identity-card.svg": 1870,
	"./icon-ekyc-detail-jumio.svg": 1871,
	"./icon-ekyc-detail-passport.svg": 1872,
	"./icon-esim-detail-copy-dark.svg": 1873,
	"./icon-esim-detail-copy-light.svg": 1874,
	"./icon-esim-detail-coverage-arrow-dark.svg": 1875,
	"./icon-esim-detail-coverage-arrow-light.svg": 1876,
	"./icon-esim-detail-error-text-field-dark.svg": 1877,
	"./icon-esim-detail-error-text-field-light.svg": 1878,
	"./icon-header-airmoney.svg": 1879,
	"./icon-header-arrow-close.svg": 1880,
	"./icon-header-language.svg": 1881,
	"./icon-header-myesim.svg": 1882,
	"./icon-header-profile.svg": 1883,
	"./icon-header-store.svg": 1884,
	"./icon-hero-rating-appstore.svg": 1885,
	"./icon-hero-rating-googleplay.svg": 1886,
	"./icon-homepage-country-arrow-close.svg": 1887,
	"./icon-homepage-country-arrow-open.svg": 1888,
	"./icon-homepage-country-data-dark-16.svg": 1889,
	"./icon-homepage-country-data-dark-22.svg": 1890,
	"./icon-homepage-country-data-light-16.svg": 1891,
	"./icon-homepage-country-data-light-22.svg": 1892,
	"./icon-info-general-dark.svg": 1893,
	"./icon-info-general-light.svg": 1894,
	"./icon-mob-website-expansion-item-arrow.svg": 1895,
	"./icon-myesims-checklist.svg": 1896,
	"./icon-myesims-nosign.svg": 1897,
	"./icon-myesims-trash-slash.svg": 1898,
	"./icon-myesims-wifi-exclamationmark.svg": 1899,
	"./icon-orders-billed-to.svg": 1900,
	"./icon-package-3g-light.svg": 864,
	"./icon-package-4g-light.svg": 865,
	"./icon-package-5g-light.svg": 866,
	"./icon-package-activation-policy-light.svg": 867,
	"./icon-package-arrow-general-light.svg": 868,
	"./icon-package-calling-credit-light.svg": 869,
	"./icon-package-coverage-dark.svg": 1901,
	"./icon-package-coverage-light.svg": 870,
	"./icon-package-ekyc-micro-light.svg": 871,
	"./icon-package-ekyc-restriction-light.svg": 872,
	"./icon-package-ekyc-validation-light.svg": 873,
	"./icon-package-fup-dark.svg": 1902,
	"./icon-package-fup-light.svg": 874,
	"./icon-package-info-general-light.svg": 875,
	"./icon-package-lte-light.svg": 876,
	"./icon-package-network-light.svg": 877,
	"./icon-package-plan-type-light.svg": 878,
	"./icon-package-price-dark.svg": 1903,
	"./icon-package-price-light.svg": 879,
	"./icon-package-supported-arrow-dark.svg": 1904,
	"./icon-package-supported-arrow-light.svg": 880,
	"./icon-package-topup-option-light.svg": 881,
	"./icon-package-validity-dark.svg": 1905,
	"./icon-package-validity-light.svg": 882,
	"./icon-partner-with-us-breadcrumb-arrow.svg": 1906,
	"./icon-password-hidden-error.svg": 1907,
	"./icon-password-hidden.svg": 1908,
	"./icon-password-visible-error.svg": 1909,
	"./icon-password-visible.svg": 1910,
	"./icon-search-clear.svg": 1911,
	"./icon-search.svg": 1912,
	"./icon-unlimited-dark.svg": 1913,
	"./icon-unlimited-light.svg": 1914,
	"./icon-website-expansion-content-box-bg-sm.svg": 1915,
	"./icon-website-expansion-content-box-bg.svg": 1916,
	"./mail.svg": 1917,
	"./order-async/my-esims/top-up-is-delayed.svg": 883,
	"./order-async/my-esims/top-up-is-failed.svg": 884,
	"./order-async/my-esims/top-up-is-on-the-way.svg": 885,
	"./settings_button.svg": 1918,
	"./tabs-Airmoney.svg": 1919,
	"./tabs-Credit-Card.svg": 1920,
	"./tabs-PayPal.svg": 1921,
	"./telegram.svg": 1922,
	"./tick-light.svg": 1923,
	"./twitter.svg": 1924,
	"./whatsapp.svg": 1925
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 859;